/** @format */

import useDetails from '@/@ducks/cardRoom/hooks/useDetails';
import BathIcon from '@/assets/icons/card-room-bath-icon.svg';
import SizeIcon from '@/assets/icons/card-room-size-icon.svg';
import RoomTypeIcon from '@/assets/icons/card-room-type-icon.svg';
import { Icon } from '@/components/ui/Icon';
import React from 'react';
import { Bathroom, RoomSize, RoomType, Wrapper } from './Details.style';
import { useCardRoomContext } from './context';

const Details: React.FC = React.memo(() => {
  const { room } = useCardRoomContext();
  const { roomFeatures, flatFeatures, flat } = room!;
  const flatType = flat?.type;
  const { RoomBathroom, roomSizeNr, type } = useDetails({ roomFeatures, flatFeatures, flatType });

  return (
    <Wrapper>
      <RoomType>
        <Icon icon={RoomTypeIcon} color="#667085" width={16} height={16} />
        <span>{type}</span>
      </RoomType>
      {roomSizeNr && (
        <RoomSize>
          <Icon icon={SizeIcon} color="#667085" width={16} height={16} />
          <span>{roomSizeNr} m²</span>
        </RoomSize>
      )}
      {RoomBathroom && (
        <Bathroom>
          <Icon icon={BathIcon} color="#667085" width={16} height={16} />
          <span>{RoomBathroom}</span>
        </Bathroom>
      )}
    </Wrapper>
  );
});

export default Details;
